// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2Yq6Y","select":"Header_select__oULBm","clinic":"Header_clinic__sDMno"};